import { GlobalMenu } from '@components';
import { NavigationContext } from '@layout/navigation/navigation';
import { AssetContext } from '@pages/Asset/Asset.query';
import { getPermissionData } from '@utils';
import { getProductValue } from '@utils/getProductValue';
import { useContext } from 'react';
import { Container } from './ContactsMenu.styles';

const ContactsMenu = () => {
  const { openAddContact, sortContactByFavorite, equipmentQuery } =
    useContext(AssetContext);
  const { role } = useContext(NavigationContext);

  const addPermission = getPermissionData({
    owner: true,
    action: 'add',
    role,
    type: 'Contact',
  });

  const equipment = equipmentQuery?.data;
  const { manufacturerId, productId } = getProductValue(equipment);
  const hasProduct = manufacturerId && productId;
  const isEnabled = addPermission.allowed && hasProduct;

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        itemList={[
          {
            label: 'Add Contact',
            iconName: 'plus',
            disabled: !isEnabled,
            disableToolTip: addPermission.allowed,
            toolTipText: addPermission.message,
            toolTipId: 'addContactTooltip',
            onClick: () => {
              if (isEnabled) {
                openAddContact.set(true);
              }
            },
          },
          {
            label: sortContactByFavorite.get()
              ? 'Remove Sort'
              : 'Sort By: Favorite',
            iconName: 'sort-alphabetical',
            onClick: () => {
              sortContactByFavorite.set(!sortContactByFavorite.get());
            },
          },
        ]}
      />
    </Container>
  );
};

export { ContactsMenu };
